const VIMEO_BASE_URL = 'https://api.vimeo.com';

const VIMEO_AUTHERIZATION = 'Bearer dc6448c9fd08c840b57639e87e681f2d';

const VIMEO_BUCKETS = {
  VIMEO_BUCKET_ENTITY_VIDEOS_STAGING: `/users/243619352/projects/26165008`,
  TEST_VIMEO_BUCKET_ENTITY_VIDEOS_STAGING: `/users/243619352/projects/27384383`,
}

const VIMEO_ROUTES = {
  ME: `${VIMEO_BASE_URL}/me`,
}

const VIMEO_ENDPOINTS = {
  VIDEOS: `${VIMEO_ROUTES.ME}/videos`,
}

export { VIMEO_BASE_URL, VIMEO_AUTHERIZATION, VIMEO_ROUTES, VIMEO_ENDPOINTS, VIMEO_BUCKETS }